<template>
    <div class="grid grid-cols-1 md:grid-cols-2 h-full bg-gray">
        <div class="h-40 md:h-full md:min-h-screen md:max-h-full overflow-hidden relative">
            <img src="../assets/login-image.jpg" alt="Sharp - Be Original" class="hidden md:block w-full h-full object-cover object-left" loading="lazy" />
            <img src="../assets/login-image-mobile.jpg" alt="Sharp - Be Original" class="block md:hidden w-full h-full object-cover object-left" loading="lazy" />
            <div class="mobile-logo-container absolute top-8 left-8 md:hidden">
                <router-link
                        :to="{ name: 'signIn' }">
                    <img src="../assets/sharp-logo.png" alt="Sharp - Be Original" class="logo--white"/>
                </router-link>
            </div>
        </div>

        <div class="md:min-h-screen md:order-first ">
            <div class="md:w-96 page-container--home mx-auto md:mt-24 sc:mt-0 py-10 md:py-5  px-8 md:px-5">
                <div class="flex flex-col w-full h-full justify-between">
                    <div class="mb-16 hidden md:block">
                        <router-link
                                :to="{ name: 'signIn' }">
                            <img src="../assets/sharp-logo.png" alt="Sharp - Be Original"/>
                        </router-link>
                    </div>

                    <div class="mb-20">
                        <h1 class="mb-5 md:mb-10">Reset your Password</h1>
                        <forgot-password-form></forgot-password-form>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script charset="utf-8">

import ForgotPasswordForm from './form/ForgotPasswordForm.vue';
import Vuex from 'vuex';

export default {
    components: {
        ForgotPasswordForm
    },

}
</script>
